/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

type Props = {
    title: string
}

const planItem = ({ title }: Props) => {
    return (
        <li className="flex items-center pb-4">
            <span className="bg-purple-500 px-1.5 py-1.5 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
            </span>
            <h1 className="text-gray-200 font-medium ml-4 text-base">{title}</h1>
        </li>
    )
}

export default planItem